export const getCollapsiblePanelStyles = (components, theme) => ({
  border: 'none',
  marginBottom: 'unset',
  backgroundColor: 'unset',

  '& .panel-heading': {
    padding: 0,
    borderBottom: 'none',
    marginBottom: 18,

    '& .panel-title': {
      fontSize: 18,
      '& > a': {
        color: theme && theme.palette && theme.palette.themePrimary,
        padding: 0,
        '&:hover, &:active': {
          color: theme && theme.palette && theme.palette.themeDarker,
          textDecoration: 'none',
          backgroundColor: 'unset',
        },
      },

      '& > a:after': {
        transform: 'rotate(180deg)',
      },

      '& > a.collapsed:after': {
        transform: 'rotate(90deg)',
      },
    },
  },

  '& .panel-collapse': {
    '& .panel-body': {
      padding: 0,
      overflow: 'hidden',
    },
  },
});
